function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "22",
  height: "22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_430_372)",
  stroke: "#AAA",
  strokeWidth: "1.375",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11 6.875V11M14.575 13.063L11 11M15.83 8.568h3.437V5.13"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.345 16.345a7.562 7.562 0 110-10.69l2.922 2.913"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_430_372"
}, /*#__PURE__*/React.createElement("rect", {
  width: "22",
  height: "22",
  rx: "11",
  fill: "#fff"
})))));